// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Platform Configuration Page */
.platform-config-page .dashboard-body {
  width: 100%;
  max-width: 900px;
  padding-bottom: 2rem;
}

.platform-hero__icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  font-size: 1.35rem;
  color: #fff;
}

.platform-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 3rem;
  color: var(--text-muted);
  font-size: 0.95rem;
}

.platform-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.platform-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.platform-card--maintenance {
  border-left: 4px solid #dc2626;
  background: linear-gradient(to right, rgba(220, 38, 38, 0.03), #fff);
}

.platform-card__header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  flex-wrap: wrap;
}

.platform-card__icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: rgba(15, 118, 110, 0.12);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.platform-card__icon--danger {
  background: rgba(220, 38, 38, 0.12);
  color: #dc2626;
}

.platform-card__icon--schedule {
  background: rgba(124, 58, 237, 0.12);
  color: #7c3aed;
}

.platform-card__header > div {
  flex: 1 1;
  min-width: 0;
}

.platform-card__title {
  margin: 0 0 0.25rem 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text);
}

.platform-card__desc {
  margin: 0;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.platform-card__body {
  padding: 0 1.5rem 1.5rem;
  border-top: 1px solid #f1f5f9;
  padding-top: 1rem;
  margin-top: 0;
}

.platform-card--maintenance .platform-card__body {
  border-top-color: rgba(220, 38, 38, 0.15);
}

/* Toggle Switch */
.platform-toggle {
  position: relative;
  display: inline-block;
  width: 52px;
  height: 28px;
  flex-shrink: 0;
  cursor: pointer;
}

.platform-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.platform-toggle__slider {
  position: absolute;
  inset: 0;
  background: #cbd5e1;
  border-radius: 28px;
  transition: 0.3s;
}

.platform-toggle__slider::before {
  content: "";
  position: absolute;
  height: 22px;
  width: 22px;
  left: 3px;
  bottom: 3px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.platform-toggle input:checked + .platform-toggle__slider {
  background: linear-gradient(135deg, #0f766e, #14b8a6);
}

.platform-toggle input:checked + .platform-toggle__slider::before {
  transform: translateX(24px);
}

.platform-toggle input:disabled + .platform-toggle__slider {
  opacity: 0.5;
  cursor: not-allowed;
}

.platform-toggle--sm {
  width: 44px;
  height: 24px;
}

.platform-toggle--sm .platform-toggle__slider::before {
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
}

.platform-toggle--sm input:checked + .platform-toggle__slider::before {
  transform: translateX(20px);
}

/* Service Grid */
.platform-services-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.platform-service-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  transition: background 0.2s;
}

.platform-service-item:hover {
  background: #f1f5f9;
}

.platform-service-item__info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.platform-service-item__icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(15, 118, 110, 0.1);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.platform-service-item__label {
  display: block;
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--text);
}

.platform-service-item__desc {
  display: block;
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 0.15rem;
}

.platform-schedule-badge {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.4rem;
  font-size: 0.75rem;
  color: #7c3aed;
}

.platform-schedule-badge i {
  margin-right: 0.2rem;
}

.platform-cancel-chip {
  padding: 0.2rem 0.5rem;
  font-size: 0.7rem;
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.platform-cancel-chip:hover:not(:disabled) {
  background: #fee2e2;
}

.platform-cancel-chip:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.platform-select {
  width: 100%;
  padding: 0.65rem 2rem 0.65rem 0.75rem;
  font-size: 0.9rem;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  appearance: auto;
}

/* Textarea */
.platform-textarea {
  width: 100%;
  padding: 0.65rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: none;
  background: none;
  color: var(--text);
  resize: vertical;
  min-height: 60px;
}

.platform-textarea:focus {
  outline: none;
}

.cp-input-wrap .platform-textarea {
  padding: 0;
}

/* Scheduled Downtime Form */
.platform-scheduled-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.platform-scheduled-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
}

@media (max-width: 768px) {
  .platform-scheduled-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .platform-scheduled-grid {
    grid-template-columns: 1fr;
  }
}

.platform-schedule-services {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.platform-schedule-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  background: #f1f5f9;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--text);
  cursor: pointer;
  border: 1px solid #e2e8f0;
  transition: all 0.2s;
}

.platform-schedule-chip:hover {
  background: #e2e8f0;
}

.platform-schedule-chip input {
  accent-color: #0f766e;
  cursor: pointer;
}

.platform-schedule-chip:has(input:checked) {
  background: rgba(15, 118, 110, 0.12);
  border-color: #0f766e;
  color: #0f766e;
}

.platform-hint {
  margin: 0.5rem 0 0 0;
  font-size: 0.8rem;
  color: var(--text-muted);
}

.platform-hint i {
  margin-right: 0.35rem;
}

/* Actions */
.platform-actions {
  margin-top: 0.5rem;
}

.platform-actions .cp-btn {
  min-width: 200px;
}

/* Confirm modal */
.platform-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: 1rem;
}

.platform-confirm-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 440px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.platform-confirm-title {
  margin: 0 0 0.5rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.platform-confirm-title i {
  color: #f59e0b;
}

.platform-confirm-text {
  margin: 0 0 1rem;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.platform-changes-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.platform-change-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
}

.platform-change-label {
  flex: 1 1;
  font-weight: 500;
  color: var(--text);
}

.platform-change-from {
  color: #94a3b8;
  min-width: 32px;
}

.platform-change-arrow {
  color: #94a3b8;
  font-size: 0.75rem;
}

.platform-change-to {
  font-weight: 600;
  color: #0f766e;
  min-width: 32px;
}

.platform-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

/* Toast */
.platform-toast {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  animation: platformToastIn 0.3s ease;
}

@keyframes platformToastIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.platform-toast--success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}

.platform-toast--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.platform-toast--info {
  background: #eff6ff;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Platform/PlatformConfigurationPage.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA,UAAU;AACV;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B","sourcesContent":["/* Platform Configuration Page */\n.platform-config-page .dashboard-body {\n  width: 100%;\n  max-width: 900px;\n  padding-bottom: 2rem;\n}\n\n.platform-hero__icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 12px;\n  font-size: 1.35rem;\n  color: #fff;\n}\n\n.platform-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 3rem;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n.platform-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.platform-card {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.platform-card--maintenance {\n  border-left: 4px solid #dc2626;\n  background: linear-gradient(to right, rgba(220, 38, 38, 0.03), #fff);\n}\n\n.platform-card__header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  flex-wrap: wrap;\n}\n\n.platform-card__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  background: rgba(15, 118, 110, 0.12);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.platform-card__icon--danger {\n  background: rgba(220, 38, 38, 0.12);\n  color: #dc2626;\n}\n\n.platform-card__icon--schedule {\n  background: rgba(124, 58, 237, 0.12);\n  color: #7c3aed;\n}\n\n.platform-card__header > div {\n  flex: 1;\n  min-width: 0;\n}\n\n.platform-card__title {\n  margin: 0 0 0.25rem 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.platform-card__desc {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.platform-card__body {\n  padding: 0 1.5rem 1.5rem;\n  border-top: 1px solid #f1f5f9;\n  padding-top: 1rem;\n  margin-top: 0;\n}\n\n.platform-card--maintenance .platform-card__body {\n  border-top-color: rgba(220, 38, 38, 0.15);\n}\n\n/* Toggle Switch */\n.platform-toggle {\n  position: relative;\n  display: inline-block;\n  width: 52px;\n  height: 28px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.platform-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.platform-toggle__slider {\n  position: absolute;\n  inset: 0;\n  background: #cbd5e1;\n  border-radius: 28px;\n  transition: 0.3s;\n}\n\n.platform-toggle__slider::before {\n  content: \"\";\n  position: absolute;\n  height: 22px;\n  width: 22px;\n  left: 3px;\n  bottom: 3px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  transition: 0.3s;\n}\n\n.platform-toggle input:checked + .platform-toggle__slider {\n  background: linear-gradient(135deg, #0f766e, #14b8a6);\n}\n\n.platform-toggle input:checked + .platform-toggle__slider::before {\n  transform: translateX(24px);\n}\n\n.platform-toggle input:disabled + .platform-toggle__slider {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.platform-toggle--sm {\n  width: 44px;\n  height: 24px;\n}\n\n.platform-toggle--sm .platform-toggle__slider::before {\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n}\n\n.platform-toggle--sm input:checked + .platform-toggle__slider::before {\n  transform: translateX(20px);\n}\n\n/* Service Grid */\n.platform-services-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.platform-service-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.85rem 1rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  transition: background 0.2s;\n}\n\n.platform-service-item:hover {\n  background: #f1f5f9;\n}\n\n.platform-service-item__info {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.platform-service-item__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: rgba(15, 118, 110, 0.1);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  flex-shrink: 0;\n}\n\n.platform-service-item__label {\n  display: block;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--text);\n}\n\n.platform-service-item__desc {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin-top: 0.15rem;\n}\n\n.platform-schedule-badge {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.4rem;\n  font-size: 0.75rem;\n  color: #7c3aed;\n}\n\n.platform-schedule-badge i {\n  margin-right: 0.2rem;\n}\n\n.platform-cancel-chip {\n  padding: 0.2rem 0.5rem;\n  font-size: 0.7rem;\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.platform-cancel-chip:hover:not(:disabled) {\n  background: #fee2e2;\n}\n\n.platform-cancel-chip:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.platform-select {\n  width: 100%;\n  padding: 0.65rem 2rem 0.65rem 0.75rem;\n  font-size: 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  appearance: auto;\n}\n\n/* Textarea */\n.platform-textarea {\n  width: 100%;\n  padding: 0.65rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: none;\n  background: none;\n  color: var(--text);\n  resize: vertical;\n  min-height: 60px;\n}\n\n.platform-textarea:focus {\n  outline: none;\n}\n\n.cp-input-wrap .platform-textarea {\n  padding: 0;\n}\n\n/* Scheduled Downtime Form */\n.platform-scheduled-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.platform-scheduled-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 1rem;\n}\n\n@media (max-width: 768px) {\n  .platform-scheduled-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .platform-scheduled-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.platform-schedule-services {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.platform-schedule-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.75rem;\n  background: #f1f5f9;\n  border-radius: 20px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: var(--text);\n  cursor: pointer;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s;\n}\n\n.platform-schedule-chip:hover {\n  background: #e2e8f0;\n}\n\n.platform-schedule-chip input {\n  accent-color: #0f766e;\n  cursor: pointer;\n}\n\n.platform-schedule-chip:has(input:checked) {\n  background: rgba(15, 118, 110, 0.12);\n  border-color: #0f766e;\n  color: #0f766e;\n}\n\n.platform-hint {\n  margin: 0.5rem 0 0 0;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n}\n\n.platform-hint i {\n  margin-right: 0.35rem;\n}\n\n/* Actions */\n.platform-actions {\n  margin-top: 0.5rem;\n}\n\n.platform-actions .cp-btn {\n  min-width: 200px;\n}\n\n/* Confirm modal */\n.platform-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n  padding: 1rem;\n}\n\n.platform-confirm-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  max-width: 440px;\n  width: 100%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n}\n\n.platform-confirm-title {\n  margin: 0 0 0.5rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.platform-confirm-title i {\n  color: #f59e0b;\n}\n\n.platform-confirm-text {\n  margin: 0 0 1rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.platform-changes-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n  padding: 1rem;\n  background: #f8fafc;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.platform-change-row {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.platform-change-label {\n  flex: 1;\n  font-weight: 500;\n  color: var(--text);\n}\n\n.platform-change-from {\n  color: #94a3b8;\n  min-width: 32px;\n}\n\n.platform-change-arrow {\n  color: #94a3b8;\n  font-size: 0.75rem;\n}\n\n.platform-change-to {\n  font-weight: 600;\n  color: #0f766e;\n  min-width: 32px;\n}\n\n.platform-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n/* Toast */\n.platform-toast {\n  position: fixed;\n  bottom: 1.5rem;\n  right: 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  z-index: 1000;\n  animation: platformToastIn 0.3s ease;\n}\n\n@keyframes platformToastIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.platform-toast--success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n\n.platform-toast--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.platform-toast--info {\n  background: #eff6ff;\n  color: #1d4ed8;\n  border: 1px solid #93c5fd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
